module.exports = __webpack_public_path__ + "img/je.cba0a791.svg";